import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ashtavinayakdarshantourbuspackage() {



  const cardData =
  {
    keyword: 'Ashtavinayak Darshan Tour Bus Package From Pune ',
    heading: 'Sanavi Travels: Ashtavinayak Darshan Tour Bus Package From Pune',
    headingDescription: 'Sanavi Travels offers reliable Ashtavinayak Darshan Tour Bus Package from Pune, providing safe, comfortable, and well-planned pilgrimage travel for families, senior citizens, religious groups, and corporate devotees. Our well-maintained fleet of Non-AC and AC buses ranging from 20, 25, 30, 32, 35, 40, 45, and 50 seaters, along with tempo travellers on request, ensures a smooth and peaceful journey throughout the Ashtavinayak circuit. With experienced and courteous drivers, knowledgeable route planning, flexible tour packages, transparent pricing, and on-time service, Sanavi Travels makes your spiritual journey stress-free and memorable. We offer convenient doorstep pickup from all major areas of Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering all eight sacred temples—Mayureshwar (Morgaon), Siddhivinayak (Siddhatek), Ballaleshwar (Pali), Varadvinayak (Mahad), Chintamani (Theur), Girijatmaj (Lonavala), Vighneshwar (Ozar), and Mahaganapati (Ranjangaon). Choose Sanavi Travels for a trusted Ashtavinayak Darshan tour bus package from Pune, ensuring devotion, comfort, safety, and a spiritually fulfilling travel experience.',

    top: 'Top Places to Visit in Ashtavinayak with Sanavi Travels',


"topPlaces": [
  {
    "title": "Moreshwar Ganpati – Morgaon",
    "description": "Moreshwar Ganpati Temple in Morgaon is considered the first and most important temple of the Ashtavinayak pilgrimage. Dedicated to Lord Ganesha as Mayureshwar, the temple is surrounded by four minarets and a fortified wall. The idol is worshipped before beginning and after completing the Ashtavinayak yatra. Moreshwar Ganpati symbolizes wisdom, prosperity, and the auspicious start of all spiritual journeys."
  },
  {
    "title": "Siddhivinayak – Siddhatek",
    "description": "Siddhivinayak Temple at Siddhatek is located on the banks of the Bhima River and is associated with Lord Vishnu’s penance to defeat demons. The temple is known for fulfilling devotees’ wishes and granting success. The idol has its trunk turned to the right, making it unique and powerful. Siddhatek represents achievement, victory, and divine blessings."
  },
  {
    "title": "Ballaleshwar – Pali",
    "description": "Ballaleshwar Temple in Pali is the only Ashtavinayak temple named after a devotee, Ballal, who was blessed by Lord Ganesha for his unwavering devotion. The temple features a beautifully carved stone structure and a sacred bell gifted by Chimaji Appa. Ballaleshwar symbolizes pure devotion, faith, and childlike surrender to the divine."
  },
  {
    "title": "Varadvinayak – Mahad",
    "description": "Varadvinayak Temple at Mahad is known for granting boons and fulfilling desires of devotees. The temple houses a simple yet powerful idol of Lord Ganesha. A unique feature is the continuously burning oil lamp that has been lit since 1892. Varadvinayak represents generosity, blessings, and divine grace."
  },
  {
    "title": "Chintamani – Theur",
    "description": "Chintamani Ganpati Temple in Theur is associated with Lord Ganesha relieving worries and mental stress. Located at the confluence of the Mula and Mutha rivers, the temple has historical significance linked to the Peshwas. Devotees believe praying here removes anxiety and restores peace of mind. Chintamani symbolizes calmness, wisdom, and mental clarity."
  },
  {
    "title": "Girijatmaj – Lenyadri",
    "description": "Girijatmaj Ganpati Temple at Lenyadri is unique as it is carved inside a Buddhist cave in the Sahyadri hills. It is believed to be the birthplace of Lord Ganesha, born to Goddess Parvati. Reached by climbing stone steps, the cave temple offers a serene and spiritual atmosphere. Girijatmaj represents birth, divine energy, and nature’s harmony."
  },
  {
    "title": "Vighnahar – Ozar",
    "description": "Vighnahar Ganpati Temple in Ozar is dedicated to Lord Ganesha as the remover of obstacles. Located near the Kukadi River, the temple features gold-plated domes and a peaceful setting. Devotees seek blessings here before important life events. Vighnahar symbolizes protection, success, and the removal of difficulties."
  },
  {
    "title": "Mahaganapati – Ranjangaon",
    "description": "Mahaganapati Temple at Ranjangaon is the eighth and final temple of the Ashtavinayak pilgrimage. The idol is believed to be powerful enough to defeat demons, as worshipped by Lord Shiva himself. The temple has a grand structure and a spiritually charged atmosphere. Mahaganapati symbolizes strength, completion, and ultimate divine power."
  }
]
,





"services": [
    {
      "name": "Ashtavinayak Darshan Tour Bus Package From Pune",
      "description": "Ashtavinayak Darshan Tour Bus Package From Pune offers comfortable and well-planned bus travel for devotees visiting all eight Ganpati temples. Ideal for families, senior citizens, and groups, this service ensures a smooth pilgrimage with spacious seating, professional drivers, and reliable scheduling for a peaceful spiritual journey."
    },
    {
      "name": "Ashtavinayak Yatra Bus Pune",
      "description": "Ashtavinayak Yatra Bus Pune provides dedicated bus services for religious yatras covering the complete Ashtavinayak circuit. Well-maintained buses and experienced chauffeurs ensure safe travel, timely temple visits, and a stress-free devotional experience for all passengers."
    },
    {
      "name": "AC Bus Ashtavinayak Darshan",
      "description": "AC Bus Ashtavinayak Darshan offers air-conditioned buses for a comfortable pilgrimage experience. Suitable for long-distance religious travel, these buses provide spacious seating and a relaxed environment, making the Ashtavinayak tour pleasant in all seasons."
    },
    {
      "name": "Luxury Bus Ashtavinayak Tour",
      "description": "Luxury Bus Ashtavinayak Tour provides premium buses with comfortable interiors for devotees seeking a refined travel experience. Ideal for families and corporate groups, this service combines spiritual travel with enhanced comfort, safety, and professional service."
    },
    {
      "name": "Family Ashtavinayak Bus Pune",
      "description": "Family Ashtavinayak Bus Pune is specially designed for families traveling together for Ganpati darshan. Spacious seating, smooth travel, and safe driving ensure a relaxed and memorable pilgrimage for devotees of all age groups."
    },
    {
      "name": "Group Travel Ashtavinayak Bus",
      "description": "Group Travel Ashtavinayak Bus caters to large groups, societies, and religious associations planning Ashtavinayak darshan. Comfortable buses and skilled drivers ensure coordinated travel, punctual darshan visits, and a smooth group pilgrimage experience."
    },
    {
      "name": "Affordable Ashtavinayak Bus Package",
      "description": "Affordable Ashtavinayak Bus Package offers budget-friendly bus tours without compromising on safety or comfort. Ideal for devotees seeking economical pilgrimage options, this service provides reliable transport, experienced drivers, and transparent pricing."
    },
    {
      "name": "Chauffeur Driven Ashtavinayak Bus",
      "description": "Chauffeur Driven Ashtavinayak Bus provides experienced and courteous drivers familiar with temple routes and travel schedules. Devotees can focus on their spiritual journey while enjoying safe, punctual, and hassle-free transportation."
    },
    {
      "name": "Best Ashtavinayak Tour Bus Pune",
      "description": "Best Ashtavinayak Tour Bus Pune offers high-quality buses and professional service for a superior darshan experience. Known for reliability, comfort, and disciplined scheduling, this service ensures a smooth and spiritually fulfilling pilgrimage."
    },
    {
      "name": "Pune Ashtavinayak Darshan Bus",
      "description": "Pune Ashtavinayak Darshan Bus provides organized bus travel from Pune covering all Ashtavinayak temples. Ideal for one-day or multi-day tours, this service ensures comfort, safety, and well-managed religious travel."
    },
    {
      "name": "Ganpati Darshan Bus Pune",
      "description": "Ganpati Darshan Bus Pune offers bus services for devotees visiting Ganpati temples, including the Ashtavinayak circuit. Spacious buses and professional drivers ensure a smooth and peaceful devotional journey."
    },
    {
      "name": "Religious Tour Bus Pune",
      "description": "Religious Tour Bus Pune provides bus travel for various religious tours and pilgrimages. Comfortable seating, safe driving, and reliable service make it suitable for temple visits, yatras, and spiritual group travel."
    },
    {
      "name": "Pilgrimage Bus Package Pune",
      "description": "Pilgrimage Bus Package Pune offers complete transport solutions for religious tours starting from Pune. Designed for comfort and convenience, these packages ensure smooth travel for devotees visiting sacred destinations."
    },
    {
      "name": "Temple Tour Bus Pune",
      "description": "Temple Tour Bus Pune provides comfortable buses for visiting temples and holy places around Maharashtra. Ideal for group travel, families, and senior citizens, this service ensures safe and well-organized temple tours."
    },
    {
      "name": "Ashtavinayak Travel Service",
      "description": "Ashtavinayak Travel Service offers reliable and well-coordinated transport for devotees undertaking the Ashtavinayak pilgrimage. With professional drivers, comfortable buses, and efficient planning, this service ensures a peaceful and memorable religious journey."
    }
  ],
  "tableData": [
    ["Ashtavinayak Darshan Tour Bus Package From Pune", "Ashtavinayak Yatra Bus Pune"],
    ["AC Bus Ashtavinayak Darshan", "Luxury Bus Ashtavinayak Tour"],
    ["Family Ashtavinayak Bus Pune", "Group Travel Ashtavinayak Bus"],
    ["Affordable Ashtavinayak Bus Package", "Chauffeur Driven Ashtavinayak Bus"],
    ["Best Ashtavinayak Tour Bus Pune", "Pune Ashtavinayak Darshan Bus"],
    ["Ganpati Darshan Bus Pune", "Religious Tour Bus Pune"],
    ["Pilgrimage Bus Package Pune", "Temple Tour Bus Pune"],
    ["Ashtavinayak Travel Service", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "Ashtavinayak Darshan Tour Bus Package From Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and reliable bus packages for Ashtavinayak Darshan tours from Pune, perfect for group pilgrimages, family trips, and spiritual journeys."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and well-serviced buses designed to provide comfort during long journeys to the Ashtavinayak temples."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe Travel",
    "WhyChoosedescription": "Our professional drivers are familiar with Pune and Ashtavinayak routes, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers upfront pricing for Ashtavinayak Darshan bus packages, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our team is available round the clock to assist with bookings, itinerary planning, and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from one-day, multi-day, or customized Ashtavinayak Darshan packages according to your group’s needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure passenger safety and hygiene during the tour."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Ashtavinayak Darshan tours from Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer Ashtavinayak Darshan bus packages from Pune?',
    answer: 'Yes, Sanavi Travels provides well-organized and comfortable bus packages for Ashtavinayak Darshan tours from Pune.'
  },
  {
    question: 'How can I book an Ashtavinayak Darshan tour package with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What type of buses are used for the Ashtavinayak Darshan tour?',
    answer: 'We provide air-conditioned and well-maintained buses suitable for group travel, ensuring comfort during the pilgrimage.'
  },
  {
    question: 'Are drivers included in the bus package?',
    answer: 'Yes, all packages include experienced and professional drivers familiar with the Ashtavinayak routes.'
  },
  {
    question: 'Is the service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel assistance.'
  },
  {
    question: 'Are the buses sanitized before the tour?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey for passenger safety.'
  },
  {
    question: 'Can I customize the Ashtavinayak Darshan bus package?',
    answer: 'Absolutely. Sanavi Travels offers customized packages according to your travel and group requirements.'
  },
  {
    question: 'What payment options are available for the bus package?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the tour?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Ashtavinayak Darshan journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vinay Kulkarni',
    feedback: 'Booked the Ashtavinayak Darshan tour bus package from Pune with Sanavi Travels. Very comfortable, punctual, and well-organized. Highly recommend!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Snehal Patil',
    feedback: 'Excellent experience! The bus was clean, AC worked perfectly, and the driver was courteous. Made our spiritual trip memorable.',
    rating: 5
  }
];







































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ashtavinayak Darshan Tour Bus Package From Pune - Sanavi Travels",
  "description": "Ashtavinayak Darshan tour bus package from Pune by Sanavi Travels for family trips, group tours, and religious pilgrimages. Choose AC and luxury buses for safe, comfortable, and affordable Ashtavinayak yatra travel.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1725"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Ashtavinayak Darshan Tour Bus Package From Pune Starting from ₹40 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Ashtavinayak Darshan tour buses from Pune with Sanavi Travels. AC and luxury buses for family trips, group tours, and religious pilgrimages at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ashtavinayakdarshantourbuspackage;